<template>
  <b-modal
    size="lg"
    hide-footer
    id="modal-component"
    :title="
      editComponent ? 'Edit système : ' + editComponent.name : 'Nouveau système'
    "
  >
    <b-form @submit.prevent="onSubmit">
      <b-row class="mb-2">
        <b-col sm="6">
          <b-card bg-variant="light">
            <b-form-group
              label="Dénomination système:"
              label-for="nested-diagnostic"
            >
              <b-form-input
                v-model="form.name"
                id="nested-diagnostic"
              ></b-form-input>
            </b-form-group>
            <b-form-group label="Niveau:" label-for="nested-diagnostic">
              <b-form-input
                v-model="form.level"
                type="number"
                id="nested-diagnostic"
              ></b-form-input>
            </b-form-group>
          </b-card>
        </b-col>
        <b-col sm="6" v-if="form.level === 1">
          <h6>Composants associés (niveau +{{ level }})</h6>
          <b-button pill @click="level = 1" :variant="level === 1 ? 'info' : 'outline-info' " class="mr-1">+1</b-button>
          <b-button pill @click="level = 2" :variant="level === 2 ? 'info' : 'outline-info' " class="mr-1">+2</b-button>
          <b-button pill @click="level = 3" :variant="level === 3 ? 'info' : 'outline-info' " class="mr-1">+3</b-button>
          <b-button pill @click="level = 4" :variant="level === 4 ? 'info' : 'outline-info' ">+4</b-button><br>
<h5>-----------------------</h5>
          <b-button
            v-for="component in subComponents"
            :key="component.id"
            class="mr-1 mb-1"
            :variant="
              form.associated && form.associated.includes(component.id)
                ? 'primary'
                : ''
            "
            @click="addAssociated(component.id)"
            >{{ component.name }}</b-button
          >
          <!-- <b-form-group
            label="Type"
            label-for="sort-by-select"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            class="mb-0"
          >
            <b-form-select
              v-model="form.typeId"
              :options="types"
              :select-size="types.length"
              required
            ></b-form-select>
          </b-form-group> -->
        </b-col>
      </b-row>

      <b-alert :variant="variant" :show="success">{{ message }}</b-alert>
      <b-button block class="mt-3 mb-3" type="submit" variant="primary"
        >{{ editComponent ? "Modifier" : "Ajouter" }}
        <b-spinner small class="ml-3" v-if="isLoading"></b-spinner>
      </b-button>
    </b-form>
  </b-modal>
</template>

<script>
// import VGrid from "@revolist/vue-datagrid";
require("json-circular-stringify");

export default {
  name: "ModalComposant",
  props: {
    editComponent: Object,
    duplicComponent: Object,
  },
  data() {
    return {
      form: {
        name: "",
      },
      success: false,
      isLoading: false,
      message: "",
      variant: "",
      level: 1,
      subComponents: [],
      associatedArray: [],
      datas: {},
    };
  },
  components: {},
  mounted() {
    this.getAll();
  },
  methods: {
    getAll() {
      fetch(process.env.VUE_APP_API_BASE_URL + "/api/v1/component/getAll", {
        method: "POST",
        // body: JSON.stringify({
        //   // componentId: 1,
        // }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.localStorage.token}`,
        },
      })
        .then((response) => response.json())
        .then((json) => {
          console.log(json);
          this.datas = json;
          // IF EDIT
          if (this.editComponent || this.duplicComponent) {
            const clone = this.editComponent
              ? this.editComponent
              : this.duplicComponent;
            this.form = clone;
            console.log(this.form);
            this.subComponents = json.component.filter(
              (item) => item.level === this.form.level + this.level
            );
          }
        });
    },
    addAssociated(componentId) {
      //   if (
      //   !multi &&
      //   this.arraySelectedComponents.some(
      //     (item) => item.level === component.level
      //   )
      // ) {
      //   // If there is, remove it and add the new component
      //   this.arraySelectedComponents = this.arraySelectedComponents.filter(
      //     (item) => item.level !== component.level
      //   );
      //   this.arraySelectedComponents.push(component);
      // } else
      if (this.associatedArray.includes(componentId)) {
        //Check if there is already a component with the same id in the array
        // If there is, remove it
        this.associatedArray = this.associatedArray.filter(
          (item) => item !== componentId
        );
      } else {
        // If not, add the new component to the array
        this.associatedArray.push(componentId);
      }
      this.form.associated = this.associatedArray;
    },
    onSubmit() {
      console.log(this.form);
      this.isLoading = true;
      // this.form.componentIds = this.form.components.map((item)=>item.id);
      if (this.duplicComponent) {
        delete this.form.id;
      }

      fetch(
        process.env.VUE_APP_API_BASE_URL +
          "/api/v1/component/" +
          (this.editComponent ? "updateComponent" : "saveComponent"),
        {
          method: "POST",
          body: JSON.stringify(this.form),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.localStorage.token}`,
          },
        }
      )
        .then((rep) => {
          this.isLoading = false;
          console.log(rep);
          this.success = true;

          if (rep.status === 200) {
            this.variant = "success";
            if (this.editComponent) {
              this.message = "Système modifié avec succès";
            } else {
              this.message = "Système ajouté avec succès";
            }
          } else {
            this.variant = "danger";

            this.message = "Erreur lors  de l'enregistrement";
          }
          setTimeout(() => {
            this.success = false;
          }, 6000);
        })
        .catch((error) => {
          this.errorMessage = error;
          console.error("There was an error!", error);
          this.isLoading = false;
        });
    },
  },
  watch: {
    level() {
      this.subComponents = this.datas.component.filter(
        (item) => item.level === this.form.level + this.level
      );
    },
  },
};
</script>
<style></style>
